var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BlBackdrop",
        {
          attrs: { label: "Create", disabled: _vm.isDisabledSubmit },
          on: {
            "backdrop-close": function($event) {
              return _vm.$emit("close-modal")
            },
            "backdrop-action": _vm.onNext
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "px-8 pt-8 pb-4 flex flex-col gap-2",
              style: { width: "40rem" }
            },
            [
              _vm.isOpenRoom
                ? _c("BlTextBody2", {
                    staticClass: "text-slate-600",
                    attrs: { text: "Open room" }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("BlTextTitle4", { attrs: { text: "Create new appointment" } }),
              _vm._v(" "),
              _vm.isOpenRoom
                ? _c("BlTextBody2", {
                    staticClass: "text-slate-800",
                    attrs: {
                      text:
                        "All therapists are available for booking in this room, as long as they have no conflicting appointments during the time slot selection."
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "overflow-y-auto",
              style: {
                width: "40rem",
                maxHeight: _vm.isOpenRoom
                  ? "calc(100vh - 18rem)"
                  : "calc(100vh - 14rem)"
              }
            },
            [
              _c("div", { staticClass: "px-8 flex flex-col gap-4 mb-4" }, [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2" },
                  [
                    _c("BlIcon", {
                      staticClass: "w-6 h-6",
                      attrs: { icon: "user-square", color: "slate-6" }
                    }),
                    _vm._v(" "),
                    _c("BlSearchSelect", {
                      staticClass: "max-w-136",
                      attrs: {
                        placeholder: "Select client",
                        fetchProperty: {
                          url:
                            "/api/v1/clients?sort=alphabetical&status=active" +
                            (_vm.therapistInput
                              ? "&user_id=" + _vm.therapistInput
                              : "") +
                            "&query=",
                          dataKey: "clients",
                          countKey: "total_clients",
                          optionKeys: { value: "id", label: "name" }
                        }
                      },
                      on: { change: _vm.onChangeClient },
                      model: {
                        value: _vm.clientInput,
                        callback: function($$v) {
                          _vm.clientInput = $$v
                        },
                        expression: "clientInput"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.isOpenRoom
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "user", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlSelectBox", {
                          staticClass: "max-w-136",
                          attrs: {
                            placeholder: _vm.therapistSelectLoading
                              ? "Loading ..."
                              : "Select therapist",
                            options: _vm.therapistOptions,
                            search: "",
                            disabled: _vm.therapist.id !== null
                          },
                          on: { change: _vm.onChangeTherapist },
                          model: {
                            value: _vm.therapistInput,
                            callback: function($$v) {
                              _vm.therapistInput = $$v
                            },
                            expression: "therapistInput"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2" },
                  [
                    _c("BlIcon", {
                      staticClass: "w-6 h-6",
                      attrs: { icon: "calendar-blank", color: "slate-6" }
                    }),
                    _vm._v(" "),
                    _c("BlInputDate", {
                      staticClass: "flex-grow",
                      attrs: { input: _vm.startDateInput },
                      on: { changed: _vm.onChangeDate }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2" },
                  [
                    _c("BlIcon", {
                      staticClass: "w-6 h-6",
                      attrs: { icon: "clock-outline", color: "slate-6" }
                    }),
                    _vm._v(" "),
                    _c("BlSelectTimeslot", {
                      staticClass: "flex-grow",
                      attrs: {
                        placeholder: _vm.timeSelectLoading
                          ? "Loading..."
                          : "Select timeslot",
                        options: _vm.timeOptions
                      },
                      on: { change: _vm.onChangeTimeSlot },
                      model: {
                        value: _vm.timeInput,
                        callback: function($$v) {
                          _vm.timeInput = $$v
                        },
                        expression: "timeInput"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isOpenRoom
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "user", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlSelectBox", {
                          staticClass: "max-w-136",
                          attrs: {
                            placeholder: _vm.therapistSelectLoading
                              ? "Loading ..."
                              : "Select therapist",
                            options: _vm.therapistOptions,
                            emptyOptions:
                              "There are no therapists available for this client because they already have slots in different rooms. Please book through their available slots instead.",
                            search: "",
                            disabled: _vm.therapist.id !== null
                          },
                          on: { change: _vm.onChangeTherapist },
                          model: {
                            value: _vm.therapistInput,
                            callback: function($$v) {
                              _vm.therapistInput = $$v
                            },
                            expression: "therapistInput"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.enableBranch
                  ? _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "location", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlSelectBox", {
                          staticClass: "max-w-136",
                          attrs: {
                            type: "branch",
                            placeholder: "Select branch",
                            options: _vm.branchOptions,
                            disabled: _vm.room.id !== null,
                            search: ""
                          },
                          on: {
                            change: function($event) {
                              _vm.branchInput = $event
                            }
                          },
                          model: {
                            value: _vm.branchInput,
                            callback: function($$v) {
                              _vm.branchInput = $$v
                            },
                            expression: "branchInput"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2" },
                  [
                    _c("BlIcon", {
                      staticClass: "w-6 h-6",
                      attrs: { icon: "door", color: "slate-6" }
                    }),
                    _vm._v(" "),
                    _c("BlSelectBox", {
                      staticClass: "max-w-136",
                      attrs: {
                        placeholder: "Select room",
                        options: _vm.roomOptions,
                        search: "",
                        disabled: _vm.room.id !== null
                      },
                      on: { change: _vm.onChangeRoom },
                      model: {
                        value: _vm.roomInput,
                        callback: function($$v) {
                          _vm.roomInput = $$v
                        },
                        expression: "roomInput"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.clientInput && _vm.timeInput.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "py-2 px-3 flex flex-col gap-2 bg-cornflower-200 rounded"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlIcon", {
                              staticClass: "h-6 w-6",
                              attrs: { icon: "piggy", color: "cornflower-8" }
                            }),
                            _vm._v(" "),
                            _c("BlTextSubtitle3", {
                              staticClass: "text-cornflower-800",
                              attrs: { text: "Credits calculation" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex flex-col gap-2" },
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-cornflower-800",
                              attrs: {
                                text:
                                  "Credits will be deducted only after the session ends. However, please be aware of the remaining credits available when creating the appointment."
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "flex flex-col gap-1" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center justify-between gap-2"
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: {
                                      text:
                                        "Credits used for this appointment(s)"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "rounded h-5.5 w-11 bg-cornflower-800 flex items-center justify-center"
                                    },
                                    [
                                      _c("BlTextSubtitle3", {
                                        staticClass: "text-cornflower-200",
                                        attrs: { text: _vm.creditsUsed }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex items-center justify-between gap-2"
                                },
                                [
                                  _c("BlTextBody2", {
                                    staticClass: "text-cornflower-800",
                                    attrs: {
                                      text:
                                        "Projected remaining credits after this session(s) is completed"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "rounded h-5.5 w-11 bg-cornflower-800 flex items-center justify-center"
                                    },
                                    [
                                      _c("BlTextSubtitle3", {
                                        staticClass: "text-cornflower-200",
                                        attrs: { text: _vm.remainingCredits }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.remainingCredits < 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "py-2 px-3 flex items-start gap-2 bg-tulip-100 rounded"
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "h-6 w-6",
                          attrs: { icon: "warning", color: "tulip-7" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex flex-col" },
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-tulip-700",
                              attrs: {
                                text:
                                  "The credits available after this appointment will be negative. Please add credits to the client's account before creating the appointment."
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.unavailableDates.length
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "rounded flex items-start gap-2 py-2 px-3 bg-tulip-100"
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "h-6 w-6",
                          attrs: { icon: "warning", color: "tulip-7" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex flex-col w-128" },
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-tulip-700",
                              attrs: { text: _vm.suffixError }
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.unavailableDates, function(date) {
                              return _c(
                                "div",
                                {
                                  key: date,
                                  staticClass: "flex items-center gap-2 px-2"
                                },
                                [
                                  _c("div", {
                                    staticClass: "rounded h-1 w-1 bg-tulip-700"
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    staticClass: "text-tulip-700",
                                    attrs: { text: date }
                                  })
                                ],
                                1
                              )
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-tulip-700",
                              attrs: {
                                text:
                                  "Please adjust the details to proceed with the availability."
                              }
                            })
                          ],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "w-full h-5 bg-grey-100 mb-4" }),
              _vm._v(" "),
              _c("div", { staticClass: "px-8" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center mb-2 cursor-pointer",
                    on: {
                      click: function($event) {
                        _vm.setAssignSupervisorsInput = !_vm.setAssignSupervisorsInput
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "pl-2 pr-4",
                        style: { transform: "scale(1.375)" }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.setAssignSupervisorsInput },
                          on: {
                            changed: function($event) {
                              _vm.setAssignSupervisorsInput = !_vm.setAssignSupervisorsInput
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlTextSubtitle1", {
                      attrs: { text: "Assign supervisor" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex mb-4" },
                  [
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "If you assign a supervisor, they will be able to view this appointment on their Sessions page without affecting their appointments and availability slots."
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.setAssignSupervisorsInput
                  ? _c(
                      "div",
                      { staticClass: "flex" },
                      [
                        _c("BlSearchBox", {
                          attrs: {
                            type: "user",
                            placeholder: "Select therapist",
                            options: _vm.assignSupervisorOptions,
                            searching: _vm.assignSupervisorsLoading,
                            drop: "up"
                          },
                          on: {
                            change: function($event) {
                              _vm.assignSupervisorsInput = $event
                            },
                            search: _vm.fetchSupervisors
                          },
                          model: {
                            value: _vm.assignSupervisorsInput,
                            callback: function($$v) {
                              _vm.assignSupervisorsInput = $$v
                            },
                            expression: "assignSupervisorsInput"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.repeatDetailsOpened
        ? _c("RepeatDetailsModal", {
            attrs: {
              title: "create",
              current: {
                startDateInput: _vm.startDateInput.model,
                intervalInput: _vm.intervalInput,
                repetitionTypeInput: _vm.repetitionTypeInput,
                repeatEndInput: _vm.repeatEndInput,
                daysOfWeekInput: _vm.daysOfWeekInput,
                dayOfMonthInput: _vm.dayOfMonthInput,
                weekOfMonthInput: _vm.weekOfMonthInput,
                endAfterInput: _vm.endAfterInput,
                occurrencesInput: _vm.occurrencesInput
              },
              availableCreditToUse: _vm.availableCreditToUse,
              durationSlots: _vm.timeInput.length
            },
            on: {
              "close-modal": function($event) {
                _vm.repeatDetailsOpened = false
              },
              "on-submit": _vm.onChangeRepeatDetails
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.creditLimitExceededOpened
        ? _c("CreditLimitExceededModal", {
            attrs: { remainingCredits: _vm.remainingCredits },
            on: {
              "close-modal": function($event) {
                _vm.creditLimitExceededOpened = false
              },
              "on-submit": _vm.onSubmit
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12c3df94", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12c3df94","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointments/modal/NewAppointmentsModal.vue
// module id = null
// module chunks = 